import React from 'react'

import { useMediaQueries, useCopyToClipboard } from 'hooks'

import { urlTo } from 'helpers/router.js'

import { showSuccessToast } from 'app/redux/actions/ui'

import Button from 'components/_old/Button/Button.jsx'
import Icon from 'components/_old/Icon/Icon.jsx'
import Link from 'components/_old/Link/Link.jsx'

import { Card } from 'components/atoms/Card'
import { ItemWithIcon } from 'components/atoms/ItemWithIcon'
import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

import ColumnarLayout, { Column } from 'components/molecules/ColumnarLayout/ColumnarLayout.jsx'

import { useStrapiBonuses } from 'app/pages/Dashboard/PromoBanner/hooks/useStrapiBonuses'
import { useReferralCode } from 'app/pages/Dashboard/UserProfile/ReferralCode/hooks/useReferralCode'

import './ReferralLinkCard.css'

const ReferralLinkCard = (): React.ReactElement => {
  const { bonuses } = useStrapiBonuses()
  const { desktop } = useMediaQueries()
  const { referralCode } = useReferralCode()
  const currentLocation = window.location.pathname + window.location.search
  const value = referralCode.link

  const handleCopy = useCopyToClipboard(value)

  const handleCopyClick = (): void => {
    handleCopy()
    showSuccessToast('Referral link copied')
  }

  return (
    <Card data-test-id="referralBanner">
      <Paper top={desktop ? 32 : 24} right={desktop ? 32 : 24} bottom={desktop ? 32 : 24} left={desktop ? 32 : 24}>
        <ColumnarLayout mods={{ padding: 'size-12' }} flexDirection={!desktop && 'column'}>
          <Column size={23} mods={{ justifyContent: 'center' }}>
            <ItemWithIcon
              icon={<Icon type="gift-40" size={40} />}
              space={desktop ? 24 : 16}
              contentVerticalAlign="center"
              content={
                <Typography size={14} lineHeight={16} tag="span">
                  {bonuses
                    ? `Share InvestEngine and earn up to ${bonuses.referFriendOrBusinessBonusMin}.`
                    : 'Share InvestEngine and earn.'}{' '}
                  <Link
                    to={urlTo('dashboard.user-profile.referral', null, {
                      back: currentLocation,
                    })}
                    data-test-id="referralBannerLink"
                  >
                    See how it works
                  </Link>
                </Typography>
              }
            />
          </Column>
          <Column size={13}>
            <Button
              className="ReferralLinkCard-Button"
              mods={{ size: 'big block', color: 'green' }}
              onClick={handleCopyClick}
            >
              <ItemWithIcon
                icon={<Icon type="copy-24" size={24} color="var(--content-on-color-default)" inline />}
                space={8}
                selfHorizontalAlign="center"
                data-test-id="referralBannerCopyLink"
                content={
                  <Typography tag="span" weight="semibold" color="var(--content-on-color-default)">
                    Copy link
                  </Typography>
                }
              />
            </Button>
          </Column>
        </ColumnarLayout>
      </Paper>
    </Card>
  )
}

export { ReferralLinkCard }
